export default "__VITE_ASSET__9c1e3c7a__"